import * as React from 'react';
import { meterApiEndpoint } from './MeterAPIEndpoints';
import { dateFormatter } from 'lib/Formatters';
import { UcSelect } from 'components/common/UcSelect';
import PropTypes from 'prop-types';

// From: https://mui.com/components/autocomplete/#Asynchronous.js
export const MeterAdminSelect = (props) => {
    const filter = {
        take: 100,
        skip: 0,
        sort: [{ field: "StartTimestamp", sort: "desc" }],
        generalSearch: "",
        extAccountNumber: props.extAccountNumber || null,
        userId: props.userId || null,
        accountId: props.value?.accountId || null,
        status: "ACTIVE",
    };

    // Ensure the filter refreshes when the extAccountNumber changes
    const filterRefresh = props.extAccountNumber || "";
    const valueRefresh = props.extAccountNumber || "";

    const getOptionLabel = (option) =>
    {
        if (option.id > -1 || option.accountId > -1)
        {
            if (props.showFullLabel) {
                return option.accountName + " - " + option.extAccountNumber + " - " + option.serialNo + " (" + dateFormatter(option.startTimestamp, true) + " to " + dateFormatter(option.endTimestamp, true, "present") + ")";
            }
    
            return option.serialNo;
        }
        return '';
    }

    return (
        <UcSelect {...props}
            filterRefresh={filterRefresh}
            valueRefresh={valueRefresh}
            apiEndPoint={meterApiEndpoint}
            defaultLabel={"Meters"}
            getOptionLabel={getOptionLabel}
            filter={filter} />
    );
};

MeterAdminSelect.propTypes = {
    extAccountNumber: PropTypes.bool,
    userId: PropTypes.number,
    value: PropTypes.any,
    showFullLabel: PropTypes.bool
};